          <template>
    <v-card class="transparent stickytopconscious" width="100%" height="100%">
        <v-card class="transparent" width="100%" flat>
            <v-parallax
            height="150"
            src="@/assets/Tribunes_Parallax_(Invert).jpeg"
            >
              
              <v-row
              align="center"
              justify="center"
            >
              <v-col class="parallaxbgcontentgrad text-center" cols="12">
                <h1 class="display-2 font-weight-thin mb-4">Financial</h1>
                <h4 class="headline">FREEDOM</h4>
              </v-col>
            </v-row>
            </v-parallax>            
            </v-card>
        <v-card color="#FFFFFF" width="100%" flat>
          <v-row
          class="fill-height ma-0"
          align="center"
          justify="center"
          >
            <v-layout row wrap class="justify-center mx-3">
                <v-flex lg4 md5 sm8 xs12 class="mx-2">
                <v-img
              class="mx-3 my-3" 
              contain
              src="@/assets/Logo_BIG.jpeg"
              max-height="300"
            ><template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular indeterminate color="pop"></v-progress-circular>
                </v-row>
              </template>
              </v-img>          
                <h1 style="text-align: center;">We Operate Nationwide</h1>
                <h3 style="text-align: center;color: gray;margin-top: 2em;">Registered with the</h3>
                 <h2 style="text-align: center;color: orange;font-size: 3.5rem;">
                    NCR
                    </h2></v-flex>
                <v-flex lg4 md5 sm8 xs12 class="mx-2">
                    <h2 class="primary--text mx-1 my-3" >About Us</h2>          
                <div>Tribunes SA consists of a team of Insolvency Practitioners and Debt Counsellors, with extensive experience and capabilities in the Industry.</div><div><br></div><div>Our goal is to ultimately rid and relieve over indebted consumers of harassment, legal action and sleepless nights caused by DEBT.</div><div><br></div><div>Based on the consumer's financial situation, we may assist them with the best advice, information and solution possible. Our many years of existence and experience, allows us the resources to assist over indebted consumers Nationwide.</div><div><br></div><div>We believe that Life happens, which sometimes forces you into circumstances out of your control with seemingly no way out. We have made it our mission to act as defenders for such consumers, in terms of their rights and best interest to overcome their financial dilemmas.</div><div>In doing so, they may once again experience financial Control, financial Relief and financial Freedom!</div><br><br><br>
                </v-flex>
                </v-layout>
        </v-row>            
            </v-card>
        <v-card color="#FAFAFA" width="100%" flat>
            <v-layout row wrap class="justify-center mx-3">
                <v-flex lg8 md9 sm8 xs12 class="mx-2">          
                <h2 style="text-align: center;">Explore our Services</h2><br><br><br>
                     <v-hover v-slot:default="{ hover }">
                        <v-card
                        :elevation="hover ? 16 : 0"
                        class="my-12"
                        color="primary"
                        dark
                        :to="'/VoluntarySequestration'"
                        >
                        <v-img
                            height="180px"
                            src="@/assets/Tribunes_Parallax_(Invert).jpeg"
                        >
                        <v-card-text
                            class="voluntarysequestrationcontentgrad"
                            style="position: relative;"
                        >
                          <v-row style="margin-left:0px;">
                          <v-col cols="1">
                            <v-btn
                            absolute
                            outlined                            
                            color="pop"
                            fab
                            :large="!MiniView"
                            :small="MiniView"
                            left
                            >                            
                            <v-icon color="white" class="iconoutline">mdi-chess-king</v-icon>
                            </v-btn>
                             </v-col>
                             <v-col class="mx-1">
                            <h3 :class="MiniView ? 'font-weight-light pop--text mb-2' : 'display-1 font-weight-light pop--text mb-2'"
                            :style="MiniView ? 'font-size: 2em;' : ''">Voluntary Sequestration</h3>
                            <h4 class="font-weight-light pop--text mb-2">Explore the process of Voluntary Sequestration</h4>
                            <div class="font-weight-light title mb-2" style="font-size: 1.2rem !important;line-height: 1.2rem!important;">
                            Unlock financial freedom with our High Court process. Swift, effective, and debt-free in 2 years. Expert guidance. Click to learn more!
                            </div>
                            </v-col>
                            </v-row>
                        </v-card-text>
                        </v-img>
                        </v-card>
                    </v-hover>
                     <v-hover v-slot:default="{ hover }">
                        <v-card
                        :elevation="hover ? 16 : 0"
                        class="my-12"
                        color="primary"
                        dark
                        :to="'/DebtCounselling'"
                        >
                        <v-img
                            height="180px"
                            src="@/assets/Parallax_Logo.jpeg"
                        >
                         <v-card-text
                            class="voluntarysequestrationcontentgrad"
                            style="position: relative;"
                        >
                          <v-row style="margin-left:0px;">
                          <v-col cols="1">
                            <v-btn
                            absolute
                            outlined                            
                            color="pop"
                            fab
                            :large="!MiniView"
                            :small="MiniView"
                            left
                            >                            
                            <v-icon color="white" class="iconoutline">mdi-chess-knight</v-icon>
                            </v-btn>
                             </v-col>
                             <v-col class="mx-1"><h3 :class="MiniView ? 'font-weight-light pop--text mb-2' : 'display-1 font-weight-light pop--text mb-2'"
                            :style="MiniView ? 'font-size: 2em;' : ''">Debt Counselling</h3>
                             <h4 class="font-weight-light pop--text mb-2">Explore the process of Debt Counselling</h4>
                            <div class="font-weight-light title mb-2" style="font-size: 1.2rem !important;line-height: 1.2rem!important;">
                            Navigate debt with the help of registered debt counsellors. Retain assets while renegotiating payments with creditors. Find tailored solutions for financial freedom. Click to learn more!
                            </div>
                            </v-col>
                            </v-row>
                        </v-card-text>
                        </v-img>
                        </v-card>
                    </v-hover>
                     <v-hover v-slot:default="{ hover }">
                        <v-card
                        :elevation="hover ? 16 : 0"
                        class="my-12"
                        color="primary"
                        dark
                        :to="'/Rehabilitation'"
                        >
                        <v-img
                            height="180px"
                            src="@/assets/Tribunes_Parallax_(Invert).jpeg"
                        >
                            
                         <v-card-text
                            class="voluntarysequestrationcontentgrad"
                            style="position: relative;"
                        >
                          <v-row style="margin-left:0px;">
                          <v-col cols="1">
                            <v-btn
                            absolute
                            outlined                            
                            color="pop"
                            fab
                            :large="!MiniView"
                            :small="MiniView"
                            left
                            >                            
                            <v-icon color="white" class="iconoutline">mdi-chess-queen</v-icon>
                            </v-btn>
                             </v-col>
                             <v-col class="mx-1">
                            <h3 :class="MiniView ? 'font-weight-light pop--text mb-2' : 'display-1 font-weight-light pop--text mb-2'"
                            :style="MiniView ? 'font-size: 2em;' : ''">Rehabilitation</h3>
                             <h4 class="font-weight-light pop--text mb-2">Explore the process of Rehabilitation</h4>
                            <div class="font-weight-light title mb-2" style="font-size: 1.2rem !important;line-height: 1.2rem!important;">
                            Restore your financial standing with early rehabilitation after sequestration. Obtain ITC clearance within 2-3 months and regain the ability to incur new debt. Click to learn more!
                            </div>
                            </v-col>
                            </v-row>
                        </v-card-text>
                        </v-img>
                        </v-card>
                    </v-hover>
                     <v-hover v-slot:default="{ hover }">
                        <v-card
                        :elevation="hover ? 16 : 0"
                        class="my-12"
                        color="primary"
                        dark
                        :to="'/Liquidation'"
                        >
                        <v-img
                            height="180px"
                            src="@/assets/Parallax_Logo.jpeg"
                        >
                         <v-card-text
                            class="voluntarysequestrationcontentgrad"
                            style="position: relative;"
                        >
                          <v-row style="margin-left:0px;">
                          <v-col cols="1">
                            <v-btn
                            absolute
                            outlined                            
                            color="pop"
                            fab
                            :large="!MiniView"
                            :small="MiniView"
                            left
                            >                            
                            <v-icon color="white" class="iconoutline">mdi-chess-rook</v-icon>
                            </v-btn>
                             </v-col>
                             <v-col class="mx-1">
                            <h3 :class="MiniView ? 'font-weight-light pop--text mb-2' : 'display-1 font-weight-light pop--text mb-2'"
                            :style="MiniView ? 'font-size: 2em;' : ''">Liquidation</h3>
                             <h4 class="font-weight-light pop--text mb-2">Explore the process of Rehabilitation</h4>
                            <div class="font-weight-light title mb-2" style="font-size: 1.2rem !important;line-height: 1.2rem!important;">
                            Efficiently dissolve your company with this process designed for insolvent companies. Prevent creditor claims and audits by taking timely action. Click to learn more!
                            </div>
                            </v-col>
                            </v-row>
                        </v-card-text>
                        </v-img>
                        </v-card>
                    </v-hover>
                </v-flex>
                </v-layout>            
            </v-card>
        <v-card color="#FFFFFF" width="100%" flat>
            <v-layout row wrap class="justify-center mx-3">
                <v-flex lg8 md9 sm8 xs12 class="mx-2">
            <v-hover v-slot:default="{ hover }" class="my-10">
                <v-card dark width ="600px" color="rgb(70,68,68)" :elevation="hover ? 16 : 0">

                  <v-card-title>
                    <span class="headline">Enquiry</span>
                  </v-card-title>
                   <v-card-text id="PostEnquiryform" style="display:none">
                    The Submission has been sent off!
                    Somebody from our office would get in contact with you
                   </v-card-text>
                    <v-form ref="Enquiryform" id="Enquiryform">
                      <v-card-text>
                            <v-text-field  class="pop--text" :rules="[rules.required]" v-model="Name" label="Name"></v-text-field>
                            <v-text-field  class="pop--text" :rules="[rules.required]" v-model="Surname" label="Surname"></v-text-field>
                            <v-text-field  class="pop--text" :rules="[rules.required]" v-model="Email" label="Email"></v-text-field>
                            <v-text-field  class="pop--text" :rules="[rules.required]" v-model="Telephone_Number" label="Telephone Number"></v-text-field>
                            <v-textarea  class="pop--text" :rules="[rules.required]" v-model="Message" label='Message'></v-textarea>
                            <v-select  class="pop--text" :rules="[rules.required]" v-model="Interest" :items="InterestOptions" label="Interest" item-text="Name"></v-select>
                      
                    
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="pop" light @click="SubmitEnquiry()">Submit</v-btn>
                      </v-card-actions>
                    </v-form>
                    </v-card>
               </v-hover>
                </v-flex>
                </v-layout>            
            </v-card>
        </v-card> 
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'
import SystemTrainingDocumentsFeed from '@/components/System/SystemTrainingDocumentsFeed';
import SystemActivitiesFeed from '@/components/System/SystemActivitiesFeed';
import SocialSitePosts from '@/components/System/SocialSitePosts';

export default {

    components: {
        SystemTrainingDocumentsFeed,
        SystemActivitiesFeed,
        SocialSitePosts,
        },
    data() {
    return {      
      UserRecord: {},
      rules: {
        youtubeurl: value => {
            const pattern = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
            return pattern.test(value) || "Not a Youtube Video Link.";
          },
          min8Chars: value => value.length >= 8 || "Min. 8 characters",
          required: value => !!value || "Required.",
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Invalid e-mail.";
          },
          url: value => {
            const urlpattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); 
            return urlpattern.test(value) || "Invalid Link.";
          }
        },
      Name: '',
      Surname: '',
      Email: '',
      Telephone_Number: '',
      Message: '',
      Interest: '',
      InterestOptions: [
  {
    "ID": 1000001,
    "Name": "Voluntary Sequestration"
  },
  {
    "ID": 1000002,
    "Name": "Debt Counselling"
  },
  {
    "ID": 1000003,
    "Name": "Rehabilitation"
  },
  {
    "ID": 1000004,
    "Name": "Liquidation"
  }
],
    }
    },
    computed:{
      MiniView(){
        return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md
      },
      userLoggedIn () {
      return this.$store.getters.user
    },
      
      
      
      
      
      
      
      
      
      

    },
    mounted () {
  window.scrollTo(0, 0)
},
    created(){
      this.FocusedViewToggle()
      this.IntranetViewToggle()
      this.CheckUser()

    },
    
    methods: {
      IntranetViewToggle(){
        this.$emit('IntranetViewToggle',false)
      },
      FocusedViewToggle(){
        this.$emit('FocusedViewToggle',false)
      },
      async CheckUser(){
            let vm = this
            await firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                  db.collection('users').doc(user.uid).onSnapshot(snapshot => {
              var userdetails = snapshot.data()

              vm.UserRecord = userdetails
              vm.UserRecord.id = user.uid
              console.log(vm.UserRecord)
                  })
                }
                else{
                }
            })
        },
          SubmitEnquiry(){
            let NewEnquiryObject ={
              CreatedOn: new Date(),
              Email: this.Email,
              Interest: this.Interest,
              Message: this.Message,
              Name: this.Name,
              SubmissionForm: 'Enquiry',
              SubmissionPage: 'Home',
              SubmissionType: 'Web Form',
              Surname: this.Surname,
              Telephone_Number: this.Telephone_Number,
              
            }
            let payload = {
              EnquiryObject: NewEnquiryObject
            }
            const functions = firebase.functions();
            const UnauthorizedEnquiry = functions.httpsCallable('UnauthorizedEnquiry');
            UnauthorizedEnquiry(payload).then(result => {
              console.log(result)
            })
            // db.collection('webformsubmissions').add(NewEnquiryObject).then(doc => {
              
            // })
            let oldform = document.getElementById('Enquiryform')
            let formheight = oldform.style.height
            //console.log('formheight',formheight)
            let newform = document.getElementById('PostEnquiryform')
            oldform.style.display = "none"
            newform.style.display = "block"
            newform.style.height = formheight
            
          },
          DateFormatter(date){
            if(date){
            let yearstring = date.split('-')[0]
              let monthstring = date.split('-')[1]
              let daystring = date.split('-')[2]
              let yearnumber = Number(yearstring)
              let monthnumber = Number(monthstring)
              let daynumber = Number(daystring)
              return new Date(yearnumber, monthnumber-1, daynumber)
              }
            else{
              return null
            }
          },

    }    
}
</script>

<style>
.parallaxbgcontentgrad {
  background-image: linear-gradient(to right, rgba(20,26,31,0.5), rgb(189,199,209, 1));
  border-top: solid #FBC925;
  border-bottom: solid #FBC925;
  border-width: 1px;
}
.voluntarysequestrationcontentgrad {
  background-image: linear-gradient(to right, rgba(20,26,31,0.8), rgb(189,199,209, 0.5));
}
.debtcounsellingcontentgrad {
  background-image: linear-gradient(to right, rgba(20,26,31,0.8), rgb(189,199,210, 0.5));
}
.rehabillitationcontentgrad {
  background-image: linear-gradient(to right, rgba(20,26,31,0.8), rgb(189,199,209, 0.5));
}
.liquidationcontentgrad {
  background-image: linear-gradient(to right, rgba(20,26,31,0.8), rgb(189,199,209, 0.5));
}
.transoutline{
    border: 1px solid black;
    background-color:pink
    /* color: rgba(255,255,255,0.05) */
}
.v-card--reveal {
    /* background-color: rgba(176, 7, 255, 0.5); */
  background-color: rgba(255, 193, 7, 0.75);
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
  z-index:10
}

.iconoutline{
  text-shadow: 0 0 3px #FF0000;
}
</style>

        
            
        